
import React from 'react'
import styled from 'styled-components'
import { LoadingOutlined } from '@ant-design/icons';


export default ({visible}) => {
	return visible ? <LoadingOutlined/> : null
	
}